import React from 'react';

import { Handshake, AttachMoney } from '@mui/icons-material';
import { RiHeartPulseFill, RiStethoscopeLine } from 'react-icons/ri';

import { gql, type FragmentType, getFragmentData } from '@ivy/gql/types';
import AcepTableSection, {
	type AcepTableSectionProps,
} from '@ivy/views/org/OrgShow/OrgProfile/AcepTableSection';

const AcepOperations_OrgFDoc = gql(/* GraphQL */ `
	fragment AcepOperations_Org on organization {
		id
		surveys: acep_org_surveys(
			where: { accepted_at: { _is_null: false } }
			order_by: [{ accepted_at: desc_nulls_last }]
			limit: 1
		) {
			partnershipsOffered: partnerships_offered
			billingDisclosure: billing_disclosure
			apps
			appsUnsupervised: apps_unsupervised
		}
	}
`);

export interface AcepOperationsProps
	extends Omit<AcepTableSectionProps, 'title' | 'items'> {
	org: FragmentType<typeof AcepOperations_OrgFDoc>;
}

const AcepOperations = ({ org: rawOrg, ...props }: AcepOperationsProps) => {
	const org = getFragmentData(AcepOperations_OrgFDoc, rawOrg);

	const survey = org.surveys[0];

	return (
		<AcepTableSection
			items={
				!survey
					? undefined
					: [
							{
								icon: <Handshake />,
								label: 'Partnerships',
								value: survey.partnershipsOffered,
							},
							{
								icon: <AttachMoney />,
								label: 'Billing & Collections Disclosure',
								value: survey.billingDisclosure,
							},
							{
								icon: <RiStethoscopeLine style={{ fontSize: '1.5rem' }} />,
								label: 'APPs in Group',
								value: survey.apps,
							},
							{
								icon: (
									<RiHeartPulseFill
										style={{
											fontSize: '1.5rem',
										}}
									/>
								),
								label: 'Unsupervised APP Care',
								value: survey.appsUnsupervised,
							},
					  ]
			}
			title='Group Operations'
			{...props}
		/>
	);
};

export default AcepOperations;
